export const addLevel2ParentLabel = (labelElements, $linkElement) =>
    labelElements.unshift(
        $linkElement
            .parents( '.navigation-level-2__item' )
            .find('.navigation-level-2-link__label')
            .text()
    );
